import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin, Tooltip } from 'antd';
import { Block } from 'components/block';
import { useBlockEditMode } from 'components/block/utils';
import { InfoCircleIcon } from 'components/icons';
import { useEmployee } from 'hooks';
import { useTechnologiesDictionary } from 'hooks/use-technologies-dictionary';
import {
  TechnologiesForm,
  TechnologiesFormProps,
} from 'user/forms/technologies-form';
import styles from './styles.less';

export const TechnologiesBlock: FC = () => {
  const { t } = useTranslation();
  const { loading: employeeLoading } = useEmployee();
  const { loading: technologyListLoading } = useTechnologiesDictionary();

  const {
    buttons: technologiesBlockButtons,
    isEditMode: editMode,
    formName,
    form,
    setIsEditMode,
  } = useBlockEditMode({
    formName: 'technologies-form',
  });

  const infoCircle = (
    <Tooltip
      overlayClassName={styles['tooltip']}
      title={
        "Primary technology is the main skill that you possess and use during your work.\
       This technology is integrated with EMS and it's impossible to update or delete it in this app.\
        Add more technologies that demonstrate your additional skills."
      }
    >
      <InfoCircleIcon />
    </Tooltip>
  );

  if (technologyListLoading || employeeLoading) {
    return (
      <Block
        title={t('Technologies')}
        subTitle={infoCircle}
        extra={technologiesBlockButtons}
      >
        <Spin />
      </Block>
    );
  }

  const technologiesFormProps: TechnologiesFormProps = {
    editMode,
    form,
    formName,
    setEditMode: setIsEditMode,
  };

  return (
    <Block
      title={t('Technologies')}
      subTitle={infoCircle}
      extra={technologiesBlockButtons}
    >
      <TechnologiesForm {...technologiesFormProps} />
    </Block>
  );
};
